import {
  ChangeDetectorRef,
  Component,
  HostListener,
  Input,
  OnInit,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxMasonryComponent, NgxMasonryOptions } from "ngx-masonry";
import { Photo } from "../../models/cameralla-photo.model";
import { DownloadService } from "../../services/download.service";
import AppShareHelper from "../../utils/helper";
import { LoadingService } from "../../services/loading.service";
import * as JSZip from "jszip";
import { saveAs } from "file-saver";

@Component({
  selector: "app-travel-kit-tab",
  templateUrl: "./travel-kit-tab.component.html",
  styleUrls: ["./travel-kit-tab.component.scss"],
})
export class TravelKitTabComponent implements OnInit {
  @Input("travelKit") travelKit: any;

  baseGroupUrl = "/user/group/";

  hasData = false;

  renderImageOptions: NgxMasonryOptions = {
    transitionDuration: "1s",
    itemSelector: ".grid-item",
    horizontalOrder: false,
  };

  benefitsAndOffer = {
    courses: [],
    posts: [],
    products: [],
  };

  wallpapers: Photo[] = [];
  onLoadImageError = false;
  @ViewChild(NgxMasonryComponent) masonry: NgxMasonryComponent;
  isMobile = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private cdr: ChangeDetectorRef,
    private downloadService: DownloadService,
    private loadingService: LoadingService
  ) {}

  ngOnInit() {
    this.baseGroupUrl =
      this.baseGroupUrl + this.activatedRoute.snapshot.paramMap.get("groupId");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.travelKit && changes.travelKit.currentValue) {
      this.travelKit = changes.travelKit.currentValue;
      this.wallpapers = this.travelKit.wallpapers.map((item) => {
        return {
          ...item,
          image: item.url,
          original: item.url,
          thumbnail: item.url,
        };
      });
      this.travelKit.recommendations.forEach((item) => {
        if (item.subCategory === "travel") {
          this.benefitsAndOffer.posts.push(item);
        } else if (item.subCategory === "photographyEquipment") {
          this.benefitsAndOffer.products.push(item);
        } else if (item.subCategory === "photographyCourse") {
          this.benefitsAndOffer.courses.push(item);
        }
      });
      if (
        this.travelKit.brandLogo &&
        this.travelKit.brandColor &&
        this.travelKit.brandFont
      ) {
        this.hasData = true;
        this.cdr.detectChanges();
        this.updateMansoryLayout();
      }
    }
  }

  ngAfterViewInit() {
    this.isMobile = this.mobileCheck();
  }

  mobileCheck(): boolean {
    const userAgent =
      navigator.userAgent || navigator.vendor || (window as any).opera;
    const isMobile =
      /(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(
        userAgent
      ) ||
      /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
        userAgent.substr(0, 4)
      );
    return isMobile;
  }

  getMetaImage(url) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error("error"));
      image.src = url;
    });
  }

  @HostListener("window:resize")
  onResize() {
    this.isMobile = this.mobileCheck();
  }

  createContent() {
    this.router.navigate([this.baseGroupUrl + "/travel-kit/"]);
  }

  onLoadImage(photo: HTMLImageElement, item: Photo) {
    const width = photo.naturalWidth;
    const height = photo.naturalHeight;
    item.width = width;
    item.height = height;
    this.updateMansoryLayout();
  }

  calculateImageSize(photo: Photo) {
    return AppShareHelper.calculateImageSize(photo);
  }

  getClassMapper(type) {
    switch (type) {
      case 1: {
        return "primary";
      }
      case 2: {
        //statements;
        return "secondary";
      }
      case 3: {
        //statements;
        return "success";
      }
      case 4: {
        //statements;
        return "danger";
      }
      case 5: {
        //statements;
        return "warning";
      }
      case 6: {
        //statements;
        return "info";
      }
      default: {
        //statements;
        return "light";
      }
    }
  }

  layoutType(count: number): string {
    switch (count) {
      case 1:
        return "horizontal";
      case 2:
      case 3:
        return "flex-column";
      case 4:
      case 5:
      case 6:
        return "grid";
      default:
        return "flex-column"; // Default to a column layout
    }
  }

  downloadAnimalPOIs(pdfUrl: string) {
    const filenameArr = pdfUrl.split("/").pop();
    this.downloadService.downloadPDF(pdfUrl, filenameArr);
  }

  updateMansoryLayout() {
    if (this.masonry) {
      setTimeout(() => {
        this.masonry.layout();
        this.masonry.reloadItems();
      }, 1000);
      this.masonry.layout();
      this.masonry.reloadItems();
    }
  }

  downloadAllWallpapers() {
    const zip = new JSZip();
    this.loadingService.start();
    const downloadPromises = this.wallpapers.map((wallpaper) => {
      return this.downloadService
        .fetchImageAsBlob(wallpaper.original)
        .then((blob) => {
          const filename =
            wallpaper.original.split("/").pop() || "wallpaper.jpg";
          zip.file(filename, blob);
        });
    });
    Promise.all(downloadPromises)
      .then(() => {
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, "wallpapers.zip");
        });
        this.loadingService.complete();
      })
      .catch((error) => {
        console.error("Error zipping files:", error);
        this.loadingService.complete();
      });
  }
}
